import { render } from "./VotingStars.vue?vue&type=template&id=3d6e125d&ts=true"
import script from "./VotingStars.vue?vue&type=script&lang=ts"
export * from "./VotingStars.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__